import { get, ref, set } from "firebase/database";
import { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { realtimeDB } from "./Backend";
import { HbrArrowLeft, HbrLiveCam, HbrPlayButtonRound } from "./MyCustomsvgicons";
import TextShortener from "./TextShortener";
import { format } from "date-fns";
import UseLayout from "./UseLayout";
import { useNavigate } from "react-router-dom";

const LiveVideoPlayer = ({vidwidth,vidheight,watching,extUrl,extTitle}) => {
    const [playing,setIsplaying]=useState(false);
    const [buffering,setBuffering]=useState(false);
    const [url,setUrl]=useState("");
    const [title,setTitle]=useState("");
    const [liveStarted,setLivestarted]=useState(false);
    const [showPlayerOverlay,setShowPlayerOverlay]=useState(false);
    const [startVideoPlayback,setStartPlayback]=useState(false);
    const [showSeekbar,setShowseekbar]=useState(true);
    const [played, setPlayed] = useState(0);
    const [trackPlayed, setTrackPlayed] = useState(0);
    const [duration, setDuration] = useState(0);
    const playerRef = useRef(null);
    const {width} = UseLayout();
    const navigate = useNavigate();
 

    useEffect(()=>{
        async function fetchVideoData() {
            const formattOday = format(new Date(),"yyyy-MM-dd");
            const childID = format(new Date(),"yyyyMMddHHmmss");
            const userName = localStorage.getItem("name_id");
            const alphabets = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
            const randomUUid = `User${Math.floor(Math.random() * 10000)}${alphabets.charAt(Math.floor(Math.random() * alphabets.length))}`

            const videoUrlsnapshot = await get(ref(realtimeDB,"videoplayer/url"));
            if (videoUrlsnapshot.exists()) {
                setUrl(videoUrlsnapshot.val());
                setStartPlayback(true);
            }
         
            const vidTitlesnapshot = await get(ref(realtimeDB,"videoplayer/title"));
            setTitle(vidTitlesnapshot.val());
            const livesnapshot = await get(ref(realtimeDB,"videoplayer/live"));
            if (livesnapshot.val() === true) {
                set(ref(realtimeDB,`livefeed/${childID}`),{
                    name: userName ? userName : randomUUid,
                    dateJoined: formattOday
                  });
            }
            setLivestarted(livesnapshot.val());
        }
        fetchVideoData();
    },[]);

    const handleProgress = (progress) => {
        setPlayed(progress.playedSeconds);
        setTrackPlayed(progress.played);
    };
    const handleDuration = (duration) => {
        setDuration(duration);
    };
    const handleSeekChange = (e) => {
        setTrackPlayed(parseFloat(e.target.value) / duration);
        playerRef.current.seekTo(parseFloat(e.target.value) / duration);
    };

    const handleVideoBuffer=()=>{
        setBuffering(true);
    };

    const handleVideoBufferend=()=>{
        setBuffering(false);
    };
    const handleOnVideoReady=()=>{
        setIsplaying(false);
    };
    const handleOnplay=()=>{
        setShowPlayerOverlay(false);
    };
    const handleOnPause=()=>{
        setShowPlayerOverlay(true);
    }
    
    const handleOnmouseEnter=()=>{
        setShowPlayerOverlay(true);
        setShowseekbar(true);

        const timeid = setTimeout(() => {
            setShowseekbar(false);
        }, 10000);
        return()=>clearTimeout(timeid);
    };
    const handleOnmouseLeave=()=>{
        setShowPlayerOverlay(false);
        // setShowseekbar(false);
    };

    const formatTime = (seconds) => {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = Math.floor(seconds % 60);
    
        return `${hrs >= 1 ? hrs.toString().padStart(2, '0') : ''}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
      };



    return ( 
        <div className="livevideoplayer" style={{width:vidwidth,height:vidheight,position:"relative",borderRadius:"10px"}} 
        onMouseOver={handleOnmouseEnter}
        onMouseOut={handleOnmouseLeave}
         onContextMenu={e => e.preventDefault()}>

            {liveStarted && 

            <div  
                style={{
                position:"absolute",
                gap:"10px",
                top:"2px",
                width:"90%",
                left:"0px",
                zIndex:"2",
                backgroundColor:"#10101080",
                display:"flex"}}>

                    <div className="helperarrow" style={{cursor:"pointer"}}>
                        <HbrArrowLeft width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>navigate("/")}/>
                    </div>

                    <div className='flex-row2'
                    style={{
                    padding:"4px",
                    gap:"3px",
                    width:"fit-content",
                    border:"none",
                    backgroundColor:"#10101080",
                    caretColor:"transparent",
                    color:"white",
                    fontWeight:"bold",
                    borderRadius:"10px",
                    animation:"fade180 2s linear infinite"}}>
                        <h4 style={{color:"white"}}>Live </h4>
                        <HbrLiveCam width="1em" height="1em" fillColour="#FFFFFF"/>
                        
                        {watching &&
                            <h4 style={{color:"white"}}>{`${watching}`}</h4>
                        }
                    </div>
                    {!playing && 
                        <div  className="videoplayertopdetails" style={{backgroundColor:"#10101050",borderRadius:"10%",padding:"5px",overflow:"hidden"}}>
                            {width <=1024 ? 
                            <TextShortener fullText={extTitle ? extTitle : title} words={5} />
                            :
                            <TextShortener fullText={extTitle ? extTitle : title} words={10} />
                            }
                                
                        </div>
                    }
            

            </div>
            }

            {startVideoPlayback && showPlayerOverlay && <div onClick={()=>setIsplaying(prev => !prev)} className="playeroverlay"></div>} 
                
            {startVideoPlayback ?
                <div  onClick={()=>setIsplaying(prev => !prev)} style={{width:"100%",height:"100%",position:"relative"}}>
                    <ReactPlayer 
                    url={extUrl ? extUrl : url}
                    playing={playing}
                    onProgress={handleProgress}
                    onDuration={handleDuration}
                    onBuffer={handleVideoBuffer}
                    onBufferEnd={handleVideoBufferend}
                    onReady={handleOnVideoReady}
                    onPlay={handleOnplay}
                    onPause={handleOnPause}
                    controls={false}
                    width={"100%"}
                    height={"100%"}
                    config={{
                        youtube:{
                            playerVars:{
                                modestbranding:1,
                                controls:0,
                                showinfo:0
                            }
                        }
                    }}
                    />
                    {
                        !liveStarted && showSeekbar &&
                        <div className="seekbarholder">
                            <input
                            className="seekbar"
                            type='range' min={0} max={duration} step='any'
                            value={trackPlayed * duration}
                            onChange={handleSeekChange}/>

                            <div className="videoTime">
                            <p style={{color:"white",fontWeight:"bold",padding:"5px"}}>
                                {formatTime(played)} / {formatTime(duration)}
                            </p> 
                            </div>
                        </div>
                    }

                </div> 
              
                    :
                    <div style={{
                        position:"absolute",
                        top:"50%",
                        left:"45%",
                        width:"50px",
                        height:"50px",
                        border: "5px solid white",
                        borderTop: "5px solid red",
                        borderRadius: "50%",
                        animation: "spin2 2s linear infinite",
                        }}>
                    </div>
            }

            {startVideoPlayback && !playing &&
                <div onClick={()=>setIsplaying(true)} style={{position:"absolute",top:"45%",left:"45%",borderRadius:"50%",padding:"10px",zIndex:"2"}}>
                    <HbrPlayButtonRound width="3em" height="3em" fillColour="white" />
                </div>                                      
            }

            {buffering && 
                <div style={{
                    position:"absolute",
                    top:"50%",
                    left:"45%",
                    width:"50px",
                    height:"50px",
                    border: "5px solid black",
                    borderTop: "5px solid white",
                    borderRadius: "50%",
                    animation: "spin2 2s linear infinite",
                    }}>
                </div>
            }
        
        </div>
     );
}
export default LiveVideoPlayer;